module.exports = __webpack_public_path__ + "img/leakage-detector-sm.1154e425.svg";